/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ExchangeRequest
 */
export interface ExchangeRequest {
  /**
   * Одноразовый авторизационный код
   * @type {string}
   * @memberof ExchangeRequest
   */
  code: string
}

/**
 * Check if a given object implements the ExchangeRequest interface.
 */
export function instanceOfExchangeRequest(
  value: object
): value is ExchangeRequest {
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function ExchangeRequestFromJSON(json: any): ExchangeRequest {
  return ExchangeRequestFromJSONTyped(json, false)
}

export function ExchangeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExchangeRequest {
  if (json == null) {
    return json
  }
  return {
    code: json['code'],
  }
}

export function ExchangeRequestToJSON(value?: ExchangeRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    code: value['code'],
  }
}
